var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2af598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009efd"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_searchsupport",
    d: "M11.715,21.086H15.7v2.343H11.715Zm-4.393-.293a1.464,1.464,0,1,0,1.464,1.464A1.464,1.464,0,0,0,7.322,20.794Zm16.226-7.147H11.715V15.99H23.548ZM7.322,13.354a1.464,1.464,0,1,0,1.464,1.464A1.464,1.464,0,0,0,7.322,13.354ZM23.548,6.618H11.715V8.961H23.548ZM7.322,6.325A1.465,1.465,0,1,0,8.786,7.789,1.464,1.464,0,0,0,7.322,6.325ZM2.343,26.476V3.513A1.173,1.173,0,0,1,3.514,2.341H26.477a1.173,1.173,0,0,1,1.171,1.172V16.752h2.343V3.513A3.519,3.519,0,0,0,26.477,0H3.514A3.519,3.519,0,0,0,0,3.513V26.476A3.519,3.519,0,0,0,3.514,29.99H17.046V27.647H3.514a1.173,1.173,0,0,1-1.172-1.171Zm26,3.523L26.01,27.665a5.278,5.278,0,1,1,1.7-1.617L30,28.342Zm-5.029-3.933a2.929,2.929,0,1,0-2.929-2.929A2.932,2.932,0,0,0,23.314,26.065Zm0,0",
    transform: "translate(0 0.001)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6b1493566b028ab62fefd2cb574827b2.svg";
export { ForwardRef as ReactComponent };